import React from "react";
import { cn } from "@/lib/utils";

const TONE = { bad: "text-[hsl(var(--v-blocked))]", warn: "text-[hsl(var(--v-assumed))]", ok: "text-[hsl(var(--v-ok))]", none: "text-foreground" };

/** Four answers in a row: big number, what it counts, the one detail that matters. Hairlines, no boxes. */
export function KpiStrip({ children, testId = "plan-kpis" }) {
  return <div className="grid grid-cols-2 gap-y-6 border-y border-black/[0.06] py-5 lg:grid-cols-4 lg:divide-x lg:divide-black/[0.06]" data-testid={testId}>{children}</div>;
}

export function Kpi({ label, value, sub, meta, tone = "none", to, onClick, testId }) {
  const Comp = to ? "a" : "button";
  const props = to ? { href: to } : { type: "button" };
  return (
    <Comp {...props} onClick={(e) => { if (onClick) { e.preventDefault(); onClick(); } }} className="group flex min-w-0 flex-col items-start px-5 text-left outline-none transition-colors first:pl-1 focus-visible:ring-2 focus-visible:ring-ring/40 lg:pl-7 lg:first:pl-1" data-testid={testId} data-tone={tone}>
      <div className={cn("k-hero truncate transition-colors group-hover:text-[hsl(var(--navy))]", TONE[tone])} data-testid={testId ? `${testId}-value` : undefined}>{value}</div>
      <div className="mt-2 text-[14px] font-medium leading-tight text-foreground/85">{label}</div>
      {sub ? <div className="mt-1 max-w-full truncate text-[13px] leading-snug text-muted-foreground" data-testid={testId ? `${testId}-sub` : undefined}>{sub}</div> : null}
      {meta ? <div className="mt-0.5 max-w-full truncate text-[12px] text-muted-foreground/80">{meta}</div> : null}
    </Comp>
  );
}
